import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AiProviderCreationFailedAction = {
	type: 'AI_PROVIDER_CREATION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AiProviderCreationFailedAction => ({
	type: 'AI_PROVIDER_CREATION_FAILED',
	payload,
});
